import { useAdaptable } from '../../AdaptableContext';
export const useCustomIcon = (icon) => {
    const adaptable = useAdaptable();
    if (!icon) {
        return icon;
    }
    return adaptable.api.userInterfaceApi.internalApi.prepareAdaptableIconDef(icon);
};
